export const columnsDataComplex = [
  {
    Header: "SPEND",
    accessor: "spend",
  },
  {
    Header: "INSTALLS",
    accessor: "installs",
  },
  {
    Header: "CPI",
    accessor: "cpi",
  },
  {
    Header: "D0",
    accessor: "days.D0.roas",
  },
  {
    Header: "D1",
    accessor: "days.D1.roas",
  },
  {
    Header: "D3",
    accessor: "days.D3.roas",
  },
  {
    Header: "D7",
    accessor: "days.D7.roas",
  },
  {
    Header: "D14",
    accessor: "days.D14.roas",
  },
  {
    Header: "D30",
    accessor: "days.D30.roas",
  },
  {
    Header: "D60",
    accessor: "days.D60.roas",
  },
  {
    Header: "D90",
    accessor: "days.D90.roas",
  },
  {
    Header: "D120",
    accessor: "days.D120.roas",
  },
  {
    Header: "D150",
    accessor: "days.D150.roas",
  },
  {
    Header: "D180",
    accessor: "days.D180.roas",
  },
  {
    Header: "D365",
    accessor: "days.D365.roas",
  },
];
